<template>
  <v-container class="mt-12 pt-8" style="background:#fafafa;">
    <v-row style="background:#fafafa;">
      <v-col cols="12" class="pa-0">
        
        <v-row class="py-1 px-5">
          <v-col cols="12" md="12" LeadsPannel>
            <v-row>
              <v-col cols="12" LEADSPANEL>
                <v-card :loading="loading">
                  <v-card-text class="py-0">
                    <v-row class="align-center">
                      <v-col cols="12">
                        <v-row class="align-center">
                          <v-col cols="2" class="text-center" TITLE>
                            <v-icon size="40" color="secondary">shopping_cart</v-icon>
                          </v-col>
                          <v-col cols="10" TITLE>
                            <div :class="`${arabic?'arFont':'enFont'} black--text`">
                              {{ i18n['import_orders'] }}
                            </div>
                            <div :class="`${arabic?'arFont':'enFont'} grey--text`">
                              {{ i18n["all_import_orders_details"] }}
                            </div>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12" class=" py-0">
                        <v-row class="align-center">
                          <v-col cols="12" md="4" class="text-center py-0" BTN>
                            <v-btn 
                              color="primary" 
                              block 
                              text
                              :loading="loading"
                              :class="`${arabic?'arFont':'enFont'}`" 
                              @click="downloadTemplate()">
                              {{ i18n['download_model_import_table'] }}
                              <v-icon right size="15">file_download</v-icon>
                            </v-btn>
                          </v-col>
                          <v-col cols="12" md="4" class="text-center py-0" BTN>
                            <v-btn 
                              color="primary" 
                              block 
                              :loading="loading"
                              :class="`${arabic?'arFont':'enFont'}`" 
                              @click="pickFile()">
                              {{ i18n['select_orders_import_file'] }}
                              <v-icon right size="15">folder_open</v-icon>
                            </v-btn>
                            <input
                              type="file"
                              style="display: none"
                              ref="fileCSV"
                              accept="csv/*"
                              @change="onFilePickedCSV"
                              
                            >
                          </v-col>
                          <v-col cols="12" md="4" class="text-center py-0" BTN>
                            <v-btn 
                              color="success" 
                              block 
                              :loading="loading"
                              :class="`${arabic?'arFont':'enFont'}`" 
                              @click="importOrders()">
                              {{  i18n['confirm_orders_import'] }}
                              <v-icon right size="15">file_upload</v-icon>
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12" md="2" :class="`${arabic?'arFont':'enFont'} text-center pa-2`">
                        <span v-if="resource.data" :class="`${arabic?'arFont':'enFont'}`"> {{ i18n['orders'] }} ({{ resource.total }})</span>
                      </v-col>
                      <v-col cols="12" md="8" class="text-center pa-2">
                        <Paging 
                          :resourceSettings="resourceSettings" 
                          :resource="resource"
                          @loadResource="loadResource"
                          @pageByNumber="pageByNumber"
                        />
                      </v-col>
                      <v-col cols="12" md="2" class="text-center pa-2">
                        <v-progress-circular v-if="loading" color="primary" :indeterminate="true"></v-progress-circular>
                      </v-col>
                      <v-col cols="12" v-for="(item, i) in import_leads" :key="'lead-item-' + i">
                        <LeadImport :item="item" :i="i" @details="details" @clipboardSuccessHandler="clipboardSuccessHandler" @clipboardErrorHandler="clipboardErrorHandler" @remove="remove" />
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Paging from '@/components/Paging'
import json2csv from 'json2csv'
import LeadImport from '@/components/LeadImport'
import axios from 'axios';
const headers = {'Accept': 'application/json'};

export default {
  components: {LeadImport, Paging},
  data() {
    return {
      loading:false,
      dialog:false,
      vresource:[],
      resource:[],
      search:null,
      rules: {
        required: value => !!value || this.i18n['required'],
        email: value => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(value) || this.i18n['valid_email']
      },
      resourceKeys:[
        
      ],
      resourceSettings:{
        resourceName:null,
        search:false,
        create:false,
        pagination:true,
      },
      newResource:{},
      editing:false,
      deleting:false,
      firstPanel:true,
      secondPanel:false,
      thirdPanel:false,
      selectedPanel:'firstPanel',
      subitems:[
        {
          text:'اضافة طلب جديد',
          icon:'add_shopping_cart',
          value:'firstPanel'
        },
        // {
        //   text:'التوصل مع الدعم',
        //   icon:'support_agent',
        //   value:'secondPanel'
        // },
      ],
      menu1:false,
      fromDate:null,
      menu2:false,
      toDate:null,
      statuses:[],
      selectedStatus:null,
      file:null,
      import_leads:null,
    }
  },
  methods: {
    downloadTemplate(){
      window.open(`https://docs.google.com/spreadsheets/d/1YbNcaae15NuqBNnC3gHQIKgKoIkCtQaS/edit`, '_blank').focus();
    },
    filterObject(item, queryText, itemText) {
      let v = Object.values(item).filter(x=>typeof x == 'string')
      let a = false
      v.forEach(x=>{
        if(x.toLowerCase().includes(queryText.toLowerCase())) a = true
      })
      if(itemText && typeof itemText == 'string' && itemText.toLowerCase().includes(queryText.toLowerCase())) a = true
      return a
    },
    clipboardSuccessHandler (){
      this.$emit('snackbarNotification', `Copied`, 'success')
    },
    clipboardErrorHandler () {
      this.$emit('snackbarNotification', `Failed`, 'error')
    },
    async pageByNumber(n){
      return new Promise(async (res, rej)=>{
        this.loading = true
        if(!this.search){
          this.resource = await this.$store.dispatch('getResource', {resource:this.$route.path, page:`?page=${n}` + this.buildFilter()})
        } else {
          this.resource = await this.$store.dispatch('postResource', {resource:this.$route.path + `/search?page=${n}`, value:this.search})
          this.$emit('snackbarNotification', `${this.i18n['number_of_orders_found']}: ${this.resource.data.length}`, 'success')
        }
        this.loading = false
      })
    },
    goTo(path) {
      this.$router.push(path).catch(x=>{})
    },
    buildFilter(){
      let filter = ``
      if(this.fromDate && this.toDate) {
        filter += `&filter[from]=${this.fromDate}&filter[to]=${this.toDate}`
      }
      if(this.selectedStatus) {
        filter += `&filter[status]=${this.selectedStatus}`
      }
      return filter
    },
    async filterLeads(){
      // console.log('filterLeads')
      await this.loadResource()
    },
    async loadResource() {
      return new Promise(async (res, rej)=>{
        this.loading = true
        if(!this.search){
          this.resource = await this.$store.dispatch('getResource', {resource:this.$route.path + '?' + this.buildFilter()})
          // console.log(this.resource)
        } else {
          // console.log('search', this.search)
          this.resource = await this.$store.dispatch('postResource', {resource:this.$route.path + `-search?` + this.buildFilter(), value:{search:this.search}})
        }
        this.loading = false
        res()
      })
    },
    async exportResource(){
      return new Promise(async (res, rej)=>{
        this.loading = true
        let exp = await this.$store.dispatch('getResource', {resource:'/leads-export' + '?' + this.buildFilter()})
        this.exportSimpleData(exp, 'leads')
        this.loading = false
        res()
      })
    },
    exportSimpleData(data, name){
      let a = json2csv.parse(data)
      // console.log(a)
      let csvContent = "data:text/csv;charset=utf-8," 
      var encodedUri =  csvContent + encodeURIComponent(a);
      var link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      let n = name ? name : 'failed_export'
      link.setAttribute("download", `${n}_${new Date().toISOString().split('T')[0]}.csv`);
      document.body.appendChild(link); // Required for FF
      link.click();
    },
    showPannel(v){
      this[v] = true
      let all = this.subitems.map(x=>x.value)
      all.filter(x=>x!=v).forEach(x=>this[x] = false)
    },
    setResourceName(){
      this.resourceSettings.resourceName = this.i18n[this.$route.path.replace('/', '')]
    },
    guessDelimiters (text, possibleDelimiters) {
			return possibleDelimiters.filter(weedOut);
			function weedOut (delimiter) {
				var cache = -1;
				return text.split('\n').every(checkLength);
				function checkLength (line) {
					if (!line) {
							return true;
					}
					var length = line.split(delimiter).length;
					if (cache < 0) {
							cache = length;
					}
					return cache === length && length > 1;
				}
			}
		},
		getArray(){
			let csv = this.pastedData
			let dels = [' ', '  ', ',', '	', '\t']
			this.delimiter = ','
			if(this.delimiter && this.delimiter > 1) {
				this.$emit('snackbarNotification', `Please export as CSV`, 'error')
				return
			}
			var lines=csv.split("\n");
			var result = [];
			var headers=lines[0].split(this.delimiter);
			for(var i=1;i<lines.length;i++){
					if (!lines[i])
							continue
					var obj = {};
					var currentline=lines[i].split(this.delimiter);
					for(var j=0;j<headers.length;j++){
							obj[headers[j]] = currentline[j];
					}
					result.push(obj);
			}
			console.log(result);
			return result
		},
		divideBulk(){
      let data = this.getArray();
      this.import_leads = data
			this.logger = `0/${data.length}\n\r`
			for (let i = 0; i < data.length / 30 + 1; i++) {
				this.logger += `BATCH: ${i} started\n\r`
				let send = data.slice((i * 200) + ( 1 * i ), ( i * 200 ) + 200 + ( 1 * i ));
				console.log(send)
				this.sendBulk(send, i)
			}
		},
		async sendBulk(data, batch){
			console.log(data);
      (async x=>{
        for (let i = 0; i < data.length; i++) {
          const send = data[i];
          await sleep(1000)
          // let a = await axios.post(`https://product.yervip.com/api/v1/bulk-remaining`, send, {headers}).then(x=>x.data)
          if(a.error) {
            this.errorLog += `${send.sku} | ${send.country} | ${a.error}\n\r`
          }
          this.logger += `BATCH: ${batch} ${i+1}/${data.length}\n\r`
        }
        console.log(data);
      })()
    },
    pickFile(){
      console.log(this.$refs)
      this.$refs.fileCSV.click()
    },
    async onFilePickedCSV (e) {
      const files = e.target.files
      var file = files[0];
      let rows = []
      let leads = []
      this.$papa.parse(file, {
          header: true,
          complete: (results) => {
              rows = results.data;
              for (let i = 0; i < rows.length; i++) {
              const row = rows[i];
              if(leads.map(x=>x.phone_number_1).includes(row.phone_number_1)) {
                let s = leads.findIndex(x=>x.phone_number_1 == row.phone_number_1)
                console.log('s', s)
                if(leads[s].order.length && leads[s].order.map(x=>x.sku).includes(row.sku)) {
                  let p = leads[s].order.findIndex(x=>x.sku == row.sku)
                  console.log('p', p)
                  leads[s].order[p].quantity = parseInt(leads[s].order[p].quantity) + parseInt(row.quantity)
                } else {
                  leads[s].order.push({sku:row.sku, quantity:row.quantity, sold_price:row.sold_price})
                }
              } else {
                let lead = {
                  country: row.country,
                  name: row.name,
                  address: row.address,
                  city: row.city,
                  free_delivery: row.free_delivery,
                  phone_number_1: row.phone_number_1,
                  phone_number_2: row.phone_number_2,
                  note: row.note,
                  prepaid_order:row.prepaid_order,
                  pre_confirmed:row.pre_confirmed,
                  business_name: row.business_name,
                  order:[
                    {sku:row.sku, quantity:row.quantity, sold_price:row.sold_price}
                  ]
                }

                if(row.external_reference && row.external_reference != '') {
                  lead.external_reference = row.external_reference;
                }
                if(row.extra_note && row.extra_note != '') {
                  lead.extra_note = row.extra_note;
                }

                if(row.no_added_delivery_fees && row.no_added_delivery_fees != '') {
                  lead.no_added_delivery_fees = row.no_added_delivery_fees;
                }

                if(row.call_center_lead && row.call_center_lead != '') {
                  lead.call_center_lead = row.call_center_lead;
                }
                
                if(row.tracking_link && row.tracking_link != '') {
                  lead.tracking_link = row.tracking_link;
                }
                leads.push(lead)
              }
            }
            this.import_leads = leads
            console.log(this.import_leads);
          }
      });
    },
    remove(i){
      this.import_leads.splice(i, 1)
    },
    async importOrders(){
      this.loading = true
      let a = await this.$store.dispatch('postResource', {resource:`/leads-bulk`, value:this.import_leads}) 
      console.log(a)
      this.loading = false
      this.goTo('/leads')
    },
    details(){

    }
  },
  computed:{
    statuses_obj(){
      return this.$store.state.statuses_obj
    },
    api(){
      return this.$store.state.settings.apiBase
    },
    users(){
      let sa = this.$store.state.user && this.$store.state.user.role == 'superadmin'
      // console.log(sa)
      return this.$store.state.users.filter(x=>{
        if(!sa) {
          return x.superior == this.$store.state.user.level
        } else return x
      })
    },
    site(){
      return this.$store.state.site
    },
    items() {
      return this.$store.state.menu
    },
    superAdmin(){
      return this.$store.state.superAdmin
    },
    isLogin() {
      return this.$store.state.centralLogin
    },
    language(){
      return this.$store.state.language
    },
    globalLoading(){
      return this.$store.state.globalLoading
    },
    user(){
      return this.$store.state.user
    },
    i18n(){
      return this.$store.state.i18n[this.$store.state.language]
    },
    arabic(){
      if(this.$store.state.language == 'ar') return true
    },
    routeTitle(){
      let main = this.$store.state.menu.filter(x=>x.path == this.$route.path)
      let sub = [].concat(...this.$store.state.menu.map(x=>x.subs)).filter(x=>x).filter(x=>x.path == this.$route.path)
      if(main.length) {
        return this.$store.state.i18n[this.$store.state.language][main[0].text]
      } else if(sub.length) {
        return this.$store.state.i18n[this.$store.state.language][sub[0].text]
      } else {
        return ''
      }
    },
    roles(){
      return this.$store.state.userRoles
    },
    notifications(){
      return this.$store.state.notifications.sort((a, b)=> b.timestamp - a.timestamp)
    },
  },
  async created(){
    this.setResourceName()
    this.$store.state.countries = await axios.get(`https://product.yervip.com/api/v1/countries-ninja`).then(x=>x.data)

  },
}
</script>

<style>

</style>